import * as types from './types';

export const refreshExpenses = () => ({
  type: types.CHANGE_EXPENSES_VERSION
});
